import { Dialog } from "primereact/dialog";
import pageTemplates from "../utils/pageTemplates";

const TemplateDialog = ({ visible, onHide, onSelect }) => (
    <Dialog
        header="Elige una plantilla para empezar"
        visible={visible}
        onHide={onHide}
        draggable={false}
        resizable={false}
        className="admin-template-dialog"
        dismissableMask
    >
        <div className="admin-template-grid">
            {pageTemplates.map((template) => (
                <div
                    key={template.id}
                    className="admin-template-card"
                    onClick={() => onSelect(template)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => { if (e.key === "Enter") onSelect(template); }}
                >
                    <div className="admin-template-card-icon"><i className={template.icon} /></div>
                    <div className="admin-template-card-info">
                        <strong>{template.label}</strong>
                        <small>{template.description}</small>
                    </div>
                </div>
            ))}
        </div>
    </Dialog>
);

export default TemplateDialog;
